"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasContentType = exports.hasFieldContentType = void 0;
const Either_1 = require("fp-ts/lib/Either");
const fields_1 = require("./fields");
function hasFieldContentType(obj) {
    var _a;
    return (hasContentType(obj) &&
        obj.__TYPE__ === fields_1.FieldContentType &&
        ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) !== undefined &&
        typeof obj.type === "string" &&
        (0, Either_1.isRight)(fields_1.FieldType.decode(obj.type)));
}
exports.hasFieldContentType = hasFieldContentType;
function hasContentType(obj) {
    return typeof obj === "object" && obj !== null && "__TYPE__" in obj;
}
exports.hasContentType = hasContentType;
